import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignalStream = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.5 27",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#231f20;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer_1-2",
				"data-name": "Layer 1",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "cls-1",
						d: "M7.42,2.83a16,16,0,0,0,0,21.34,1.69,1.69,0,0,1-2.49,2.29A19.49,19.49,0,0,1,4.93.55,1.69,1.69,0,0,1,7.42,2.83Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-1",
						d: "M13.07,8.43a7.9,7.9,0,0,0,0,10.15,1.69,1.69,0,0,1-2.54,2.23,11.38,11.38,0,0,1,0-14.61A1.76,1.76,0,0,1,12.91,6,1.76,1.76,0,0,1,13.07,8.43Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-1",
						d: "M23.06,13.56a2.8,2.8,0,0,1-2.81,2.75,2.9,2.9,0,0,1-2.81-2.87,2.79,2.79,0,0,1,2.81-2.75A2.9,2.9,0,0,1,23.06,13.56Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-1",
						d: "M30,6.13a11.4,11.4,0,0,1,0,14.61,1.69,1.69,0,0,1-1.27.57,2.08,2.08,0,0,1-1.12-.42,1.68,1.68,0,0,1-.15-2.38,7.89,7.89,0,0,0,0-10.14A1.69,1.69,0,0,1,27.58,6,1.84,1.84,0,0,1,30,6.13Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-1",
						d: "M35.57,26.46a1.69,1.69,0,0,1-2.49-2.29,16,16,0,0,0,0-21.34A1.69,1.69,0,0,1,35.57.54,19.51,19.51,0,0,1,35.57,26.46Z"
					})
				]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgSignalStream);
export default ForwardRef;
